import { createReducer } from 'redux-act';

import {
  CHILD_COMPONENT_FETCH_INIT,
  CHILD_COMPONENT_FETCH_SUCCESS,
  CHILD_COMPONENT_FETCH_FAIL,
  CHILD_COMPONENT_CREATE_INIT,
  CHILD_COMPONENT_CREATE_SUCCESS,
  CHILD_COMPONENT_CREATE_FAIL,
  CHILD_COMPONENT_UPDATE_INIT,
  CHILD_COMPONENT_UPDATE_SUCCESS,
  CHILD_COMPONENT_UPDATE_FAIL,
  CHILD_COMPONENT_DELETE_INIT,
  CHILD_COMPONENT_DELETE_SUCCESS,
  CHILD_COMPONENT_DELETE_FAIL,
  CHILD_COMPONENT_CLEAR,
} from 'state/actions/childComponent';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
};

export const childComponentReducer = createReducer(
  {
    [CHILD_COMPONENT_FETCH_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [CHILD_COMPONENT_FETCH_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      loading: false,
      error: null,
    }),
    [CHILD_COMPONENT_FETCH_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [CHILD_COMPONENT_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
      success: false,
    }),
    [CHILD_COMPONENT_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.child),
      loading: false,
      error: null,
      success: true,
    }),
    [CHILD_COMPONENT_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
      success: false,
    }),
    [CHILD_COMPONENT_UPDATE_INIT]: (state) => ({
      ...state,
      loading: true,
      success: false,
    }),
    [CHILD_COMPONENT_UPDATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) =>
        item._id === payload.child._id ? payload.child : item
      ),
      loading: false,
      error: null,
      success: true,
    }),
    [CHILD_COMPONENT_UPDATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
      success: false,
    }),
    [CHILD_COMPONENT_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [CHILD_COMPONENT_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false,
      error: null,
    }),
    [CHILD_COMPONENT_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [CHILD_COMPONENT_CLEAR]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
    }),
  },
  initialState
);
